var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-form" },
    [
      _c(
        "el-form",
        {
          attrs: {
            "button-class": "btn btn-green btn-sm btn-rounded font-bold",
            loading: _vm.loading,
            success: _vm.success,
            error: _vm.server_error,
            "submit-text": _vm.translations.send_label,
            disclaimer: _vm.translations.required_text
          },
          on: { submit: _vm.submit }
        },
        [
          _c("el-input", {
            staticClass: "mb-16",
            attrs: { rules: "required", label: _vm.translations.name_label },
            model: {
              value: _vm.formData.name,
              callback: function($$v) {
                _vm.$set(_vm.formData, "name", $$v)
              },
              expression: "formData.name"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "mb-16",
            attrs: {
              rules: "required|email",
              label: _vm.translations.email_label
            },
            model: {
              value: _vm.formData.email,
              callback: function($$v) {
                _vm.$set(_vm.formData, "email", $$v)
              },
              expression: "formData.email"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "mb-24",
            attrs: {
              rules: "required",
              label: _vm.translations.message_label,
              type: "textarea"
            },
            model: {
              value: _vm.formData.description,
              callback: function($$v) {
                _vm.$set(_vm.formData, "description", $$v)
              },
              expression: "formData.description"
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "text-blue opacity-50 text-10 mt-16" }, [
            _vm._v("Deze site wordt beschermd door reCAPTCHA en het Google "),
            _c(
              "a",
              {
                staticClass: "underline hover:no-underline",
                attrs: { href: "https://policies.google.com/privacy" }
              },
              [_vm._v("Privacybeleid")]
            ),
            _vm._v(" en "),
            _c(
              "a",
              {
                staticClass: "underline hover:no-underline",
                attrs: { href: "https://policies.google.com/terms" }
              },
              [_vm._v("Servicevoorwaarden")]
            ),
            _vm._v(" zijn van toepassing.")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }